import '@/App.css';
import { useEffect, useState } from 'react';
import HorecaLanding from '@/pages/horeca/HorecaLanding';
import AdminLeads from '@/pages/horeca/AdminLeads';

// Sadece bu URL'yi bilenler erişebilir — hiçbir yerden link edilmez
const ADMIN_SLUG = '/panel-py5katicn2iotmpw';

function App() {
  const [isAdmin, setIsAdmin] = useState(
    typeof window !== 'undefined' && window.location.pathname.startsWith(ADMIN_SLUG)
  );

  useEffect(() => {
    const onPop = () => {
      setIsAdmin(window.location.pathname.startsWith(ADMIN_SLUG));
    };
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);

  return isAdmin ? <AdminLeads /> : <HorecaLanding />;
}

export default App;
